import { createContext } from 'react'

import { Theme } from '@lyrahealth-inc/shared-app-logic'

export interface ForcedThemeState {
  /**
   * The currently forced theme. When null, the user's preference is used.
   * When set to Theme.DARK or Theme.LIGHT, this overrides the user's preference.
   */
  forcedTheme: Theme | null
  /**
   * Set the forced theme override. Pass null to remove the override.
   */
  setForcedTheme: (theme: Theme | null) => void
}

export const ForcedThemeContext = createContext<ForcedThemeState>({
  forcedTheme: null,
  setForcedTheme: () => {},
})
